import { render, staticRenderFns } from "./EmploymentContractList.vue?vue&type=template&id=0b4174a5&"
import script from "./EmploymentContractList.vue?vue&type=script&lang=js&"
export * from "./EmploymentContractList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports